import React, { useEffect } from "react";
import Card from "src/componets/Card";
import { ChallengeInterface } from "src/store/mine_craft/challengesSlice";
import Rewards from "../../Rewards/_partials/_List";
import { useSearchParams } from "react-router-dom";
import { queryParams } from "../../../../helpers/UrlHelpers";
import { useAppDispatch } from "../../../../store/hooks";
import AddonsList from "../../Addons/_partials/_List";
import EditAddon from "../../Addons/Edit";
import { fetchChallengesAddons } from "src/actions/mine_craft/challengesActions";
import Wrapper from "../../../../componets/Wrapper";
import Filter from "../../../../componets/Filter";

const LIMIT = 20;
const DEFAULT_ORDER_BY = 'challenge_points';
const DEFAULT_ORDER = 'desc';

const _Details = ({ challenge }: { challenge: ChallengeInterface | undefined }) => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const currentPage = queryParams.getInt(searchParams,'page') || 1;

  useEffect(() => {
    if (!challenge?.id) {
      return;
    }

    const params: any = queryParams.requestParams(
      searchParams,
      {
        limit:  LIMIT,
        offset: (currentPage - 1) * LIMIT,
        challenge_id: challenge.id
      },
      ['term', 'order_by', 'order', 'date_from', 'date_to'],
      { 'order_by': DEFAULT_ORDER_BY, 'order': DEFAULT_ORDER }
    );

    dispatch(fetchChallengesAddons({ id: challenge.id, params }))
  }, [searchParams, challenge?.id, currentPage, dispatch]);

  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Description</h4>
        {challenge?.description}
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Rewards</h4>
        {challenge?.id && <Rewards challenge_id={challenge?.id} />}
      </Card>

      <Wrapper type='type-1' border className='v-mb-10'>
        <Filter
          search
          dateRange
          orderBy={
            {
              defaultKey: DEFAULT_ORDER_BY,
              defaultSort: DEFAULT_ORDER,
              items: [
                { name: 'Date', key: 'id' },
                { name: 'Rank', key: 'challenge_points' },
                { name: 'Likes', key: 'likes_count' },
              ]
            }
          }
        />
      </Wrapper>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Posts</h4>

        <AddonsList
          limit={LIMIT}
          statsKeys={['likes', 'challenges']}
          overflowCount={99}
        />
      </Card>

      <EditAddon />
    </>
  );
}

export default _Details;
